import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn/ui canonical helper — keeps utility-class collisions resolved.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
